import { capitalize, trim, video } from '../utils/utils';
import { AnalyticsEvents as PUB } from '../../common/config/api.js';

export const ngxValidators = {
  ngxcustom: function() {
    // Apply custom validation from form designer
    return {
      validate: function(val, attrVal, c) {
        var fn = NGX.entryForm.customValidations[attrVal];
        if ('function' === typeof fn) {
          return fn.call(window, val, c.$element);
        }
        return true;
      },
      priority: 512,
    };
  },
  // Validate video URL's for video URL fields
  videourl: function() {
    return {
      validate: function(val, attrVal, c) {
        if (c.isRequired && val === '') {
          // This type of error needs to be handled by the default validator
          return true;
        }
        var videoChecks = _.map(attrVal.split(','), function(it) {
          return 'is' + capitalize(it);
        });
        var isValid = false;
        _.each(videoChecks, function(fnName) {
          if ('function' === typeof video[fnName]) {
            if (isValid || video[fnName].call(window, val, c.$element)) {
              isValid = true;
            }
          }
        });

        // WYN-1100 Additionally, ensure all urls are prefixed with a valid protocol.
        var protocolRegExp = /^(http|https):\/\//g.test(val);
        if (!protocolRegExp) {
          isValid = false;
        }

        return isValid;
      },
      priority: 256,
    };
  },

  relativedate: function() {
    return {
      validate: function(val, settings, c) {
        if (c.isRequired && val === '') {
          // This type of error needs to be handled by the default validator
          return true;
        }
        var value = new Date(val).getTime();
        if (typeof value === 'number' && isNaN(value)) {
          return false;
        }

        var today = new Date();
        today.setHours(0);
        today.setMinutes(0, 0, 0);

        switch (settings) {
          case 'future':
            return value > today.getTime();
          case 'past':
            return value < today.getTime();
        }
        return true;
      },
      priority: 1024,
    };
  },

  // Validate markup, only certain tags are allowed
  markup: function() {
    return {
      validate: function(val, attrVal, c) {
        var acceptable = 'b|i|em|u|p|br|span|a'.split('|'),
          re = /<[^>]+>/g,
          matches = val.match(re),
          badTags = false;

        if (/<!/.test(val)) return false;

        var acceptTag = function(tag) {
          var tagName = tag.replace(/[<>\/]/g, '').toLowerCase();
          if (!_.contains(acceptable, tagName)) {
            return false;
          }
          return true;
        };

        _.each(matches, function(match) {
          if (!acceptTag(match)) badTags = true;
          return;
        });

        if (badTags) return false;

        return true;
      },
      priority: 1024,
    };
  },

  // Validate file upload field
  fileupload: function() {
    return {
      validate: function(val, required, field) {
        var valid = false;
        field.options.validateIfUnchanged = true;

        // If field is optional AND is also currently blank, then do not run validation.
        if (required == false && !val) {
          return true;
          // Othewise, always run validation.
        } else {
          // Some defaults.
          var filename = null,
            filesize = undefined,
            maxSize = 0,
            fieldEl = field.$element;

          // If we are an actual file field.
          if (fieldEl && fieldEl.attr('type') == 'file') {
            // Get a handle on the file and read its attributes.
            if (!(window.FileReader && window.File)) {
              // Old browser fallback
              filename = field.$element.get(0).value || null;
            } else {
              var theFile = field.$element.get(0).files[0];
              filename = theFile ? theFile.name : null;

              maxSize = parseInt(field.$element.attr('data-ngx-maxsize'));
              if (!isNaN(maxSize) && maxSize > 0) {
                filesize = theFile ? theFile.size : null;
              }
            }

            // Check we have a filename.
            if (filename) {
              field.$element.attr('data-parsley-value', filename);
              valid = true;

              // If video type, then also check valid file extensions.
              const fileType = fieldEl.attr('data-ngx-type');
              if (fileType === 'video') {
                const allowedExtensions = fieldEl
                  .attr('data-ngx-accept')
                  .toLowerCase()
                  .replace('video/*', '');
                const extension = filename
                  .split('.')
                  .pop()
                  .toLowerCase();
                if (allowedExtensions.indexOf(extension) === -1) {
                  valid = false;
                }
              }
            } else {
              field.$element.attr('data-parsley-value', '');
              valid = false;
            }

            // Check the max filesize (if required).
            if (filesize && filesize > maxSize) valid = false;

            // If we are a text field pretending to be a file field (ie accepting Youtube URL's).
          } else if (fieldEl && fieldEl.attr('type') == 'text') {
            if (val !== '' && val !== '-') {
              valid = true;
            } else {
              valid = false;
            }
          }

          return valid;
        }
      },
      priority: 256,
    };
  },
};

export const compositeValidators = {
  // check user has entered a full name and it doesn't contain bad characters
  // TODO: i18n
  name: {
    msg: 'Please enter your full name',
    fn:  function(control, isSecondary = false, container = document) {
      var $control = $(this),
        includeTitle = $control.hasClass('xFormatNameTitle') || $control.hasClass('xFormatNameTitleLastFirst'),
        onlyFirstName = $control.hasClass('xFormatNameNotitle_f'),
        isRequired = $control.hasClass('xRequired');

      var getVal = function(selector) {
        var selectorSuffix = isSecondary ? '_Secondary' : '',
          $el = $('#' + control + '_' + selector + selectorSuffix, container),
          val = trim($el.val());

        // WYN-905 Match regular expression used on backend. Unicode shortcuts \p{L} are not natively supported
        // in Javascript. We are using Babel (babel-plugin-transform-unicode-property-regex) to transfrom
        // the shortcut into correponding Unicode character ranges.
        // Additional unicode ranges not covered by babel:
        // \u0e00-\u0e7e - Thai
        var rxp = /^[\p{L}0-9-_\.!@' \u0e00-\u0e7e]*$/gu.test(val);

        return val && rxp === true;
      };

      var getKey = function(selector) {
        var selectorSuffix = isSecondary ? '_Secondary' : '',
          $el = $('#' + control + '_' + selector + selectorSuffix, container);
        return $el.attr('data-ngx-subfield-error-key');
      };

      var errorTypes = { [getKey('Firstname')]: getVal('Firstname') };
      if (!onlyFirstName) {
        errorTypes[getKey('Lastname')] = getVal('Lastname');
      }
      errorTypes.valid = !!errorTypes.FirstName && (onlyFirstName || !!errorTypes.LastName);
      errorTypes.isRequiredFailed =
        isRequired && (errorTypes.FirstName.length === 0 || (!onlyFirstName && errorTypes.LastName.length === 0));
      if (includeTitle) {
        errorTypes[getKey('Title')] = getVal('Title');
        errorTypes.valid = !!errorTypes.valid && !!errorTypes.Title;
        errorTypes.isRequiredFailed = errorTypes.isRequiredFailed || (isRequired && errorTypes.Title.length === 0);
      }
      return errorTypes;
    },
  },
  // check user has entered a full address and it doesn't contain bad characters
  // TODO: i18n
  address: {
    msg: 'Please enter your full address',
    fn:  function(control, isSecondary = false, container = document) {
      var selectorSuffix = isSecondary ? '_Secondary' : '';

      var $control = $('[data-ngx-control="' + control + '"]', container),
        includeCountry = $control.hasClass('hasCountry'),
        validateUSAddress =
          $control.hasClass('xFormatAddressUs') && (includeCountry && $('#' + control + '_Country', container).val() === 'USA'),
        validateUKAddress =
          $control.hasClass('xFormatAddressUk') || (includeCountry && $('#' + control + '_Country', container).val() === 'GBR');
      var isRequired = $('[data-ngx-control="' + control + '"]', container).hasClass('xRequired');

      var getValueValidity = function(selector) {
          var $el = $('#' + control + '_' + selector + selectorSuffix, container),
            val = trim($el.val()),
            rxp = /<|>|\\|"|\*|%|;|\{|\}|&|\+|\n|\r/g.test(val);
          return val && val !== '' && rxp === false ? true : false;
        },
        getValue = function(selector) {
          var $el = $('#' + control + '_' + selector + selectorSuffix, container);
          return trim($el.val());
        },
        checkZip = function() {
          // If US address format, only 5 chars or 9 chars is valid
          if (validateUSAddress) {
            var _zipVal = $('#' + control + '_Zip', container).val();
            return !isNaN(_zipVal) && (_zipVal.length === 5 || _zipVal.length === 9 || _zipVal.length === 10);
          }
          return true;
        },
        checkState = function() {
          if (validateUSAddress) {
            return getValueValidity('State');
          }
          return true;
        },
        getKey = function(selector) {
          var selectorSuffix = isSecondary ? '_Secondary' : '',
            $el = $('#' + control + '_' + selector + selectorSuffix, container);
          return $el.attr('data-ngx-subfield-error-key');
        };

      var errorTypes = {
        [getKey('Address1')]: getValueValidity('Address1'),
        [getKey('City')]:     getValueValidity('City'),
      };
      errorTypes.valid = !!errorTypes.Address1 && !!errorTypes.City;
      errorTypes.isRequiredFailed = isRequired && (!getValue('Address1') || !getValue('City'));
      if (includeCountry) {
        errorTypes[getKey('Country')] = getValueValidity('Country');
        errorTypes.valid = errorTypes.valid && !!errorTypes.Country;
        errorTypes.isRequiredFailed = errorTypes.isRequiredFailed || !getValue('Country');
      }
      if (validateUKAddress) {
        errorTypes[getKey('Zip')] = getValueValidity('Zip');
        errorTypes.valid = !!errorTypes.valid && !!errorTypes.Zip;
        errorTypes.isRequiredFailed = errorTypes.isRequiredFailed || !getValue('Zip');
      } else if (validateUSAddress) {
        errorTypes = Object.assign(errorTypes, {
          [getKey('State')]: checkState(),
          [getKey('Zip')]:   getValueValidity('Zip') && checkZip(),
        });
        errorTypes.valid = !!errorTypes.valid && !!errorTypes.State && !!errorTypes.Zip;
        errorTypes.isRequiredFailed = errorTypes.isRequiredFailed || !getValue('State') || !getValue('Zip');
      }
      return errorTypes;
    },
  },
  // confirm the date entered is <18 years ago. use data-minage to control this value.
  /**
   * TODO: DOB validation is really heavy, but it kinda needs to be for accuracy and to support both 2/4 char formats.
   * at a later date look at doing a speedy check to see if it's within a year either way of the target date *THEN* do
   * the actual date validation to quickly filter out bad dates without too much processing.
   */
  date_of_birth: {
    fn: function(controlName, isSecondary = false, container = document) {
      var selectorSuffix = isSecondary ? '_Secondary' : '';

      var _datecompare,
        // check the year value and try to handle the input
        checkYear = function(dVal, now) {
          // try to set a sensible date
          var validYear = function(v, d) {
            var nowSuffix,
              yearPrefix,
              $yearEl = $('#' + controlName + '_year' + selectorSuffix, container);
            // 2-character dates are handled semi-intelligently, based on the current year
            if (v && v >= 0 && v <= 99) {
              // get last 2 digits of the current year
              nowSuffix = d.year() % 100;
              // round down to the nearest integer to get first 2 characters
              yearPrefix = Math.round(d.year() / 100) - (v > nowSuffix ? 1 : 0);
              // build the new date (as Number)
              dobObj.year = yearPrefix * 100 + v;
              // update the val without triggering validation (field blur event handles this to avoid stacking .one() events)
              $yearEl.data('value', dobObj.year);
              // after all that we've probably got a reasonable stab at a date
              return true;
            }
            // yuck
            $yearEl.data('value', dobObj.year);
            // 4-character dates are cool
            if (v >= 1900 && v <= 9999 && v <= $yearEl.attr('max')) return true;
            // otherwise it's no good
            return false;
          };

          return _.isNumber(dVal) && validYear(dVal, now);
        },
        checkMonth = function(mVal, now) {
          return !isNaN(mVal);
        },
        checkDay = function(dVal, now) {
          // try to set a sensible date
          var validDay = function(v, d) {
            var $dayEl = $('#' + controlName + '_day' + selectorSuffix, container);
            $dayEl.data('value', dobObj.day);
            if (v >= 1 && v <= 31) return true;
            // otherwise it's no good
            return false;
          };

          return _.isNumber(dVal) && validDay(dVal, now);
        },
        getVal = function(selector) {
          return parseInt($('#' + controlName + '_' + selector + selectorSuffix, container).val(), 10);
        },
        getAge = function(age) {
          var ageInt = parseInt(age, 10);
          if (!_.isNumber(ageInt)) ageInt = 18;

          return ageInt - 2 * ageInt;
        },
        getKey = function(selector) {
          var selectorSuffix = isSecondary ? '_Secondary' : '',
            $el = $('#' + controlName + '_' + selector + selectorSuffix, container);
          return $el.attr('data-ngx-subfield-error-key');
        },
        dobObj = {
          day:   getVal('day'),
          month: getVal('month'),
          year:  getVal('year'),
        },
        now = moment(parseInt(this.attr('data-ngx-datecompare'))),
        dob, // <-- don't build these unless we need to. they are expensive.
        isRequired = $('[data-ngx-control="' + controlName + '"]', container).hasClass('xRequired');

      // we need to have some data here to do anything
      var errorTypes = {
        [getKey('day')]:   checkDay.call(this, dobObj.day, now),
        [getKey('month')]: checkMonth.call(this, dobObj.month, now),
        [getKey('year')]:  checkYear.call(this, dobObj.year, now),
      };
      errorTypes.valid = !!errorTypes[getKey('day')] && !!errorTypes[getKey('month')] && !!errorTypes[getKey('year')];
      errorTypes.isRequiredFailed = isRequired && (isNaN(dobObj.day) || isNaN(dobObj.month) || isNaN(dobObj.year));

      if (errorTypes.valid) {
        // modify because moment uses a 0 based index
        --dobObj.month;
        // build the date object
        dob = moment.utc(dobObj);
        // update hidden field yo
        $('#' + controlName, container).val(dob.format());
        // make sure it's a good date
        if (dob.isValid()) {
          var yearsDiff = dob.diff(now, 'years');

          var coppaEnabled = this.attr('data-ngx-coppa') === 'enabled';
          var coppaFailed = coppaEnabled && yearsDiff > -13;

          // API needs to know if the status if coppa is enabled
          if (coppaEnabled) {
            if (coppaFailed) {
              NGX.Analytics.trigger(PUB.FORM_COPPA_FAILED);
            } else {
              NGX.Analytics.trigger(PUB.FORM_COPPA_PASSED);
            }
          }

          if (coppaFailed) {
            // is this a remember me campaign?
            const rememberMeEnabled = document.getElementById('xReturningUserForm') ? true : false;

            // If it is...
            if (rememberMeEnabled) {
              // Gate the campaign, use the users email address as the unique value.
              NGX.App.api.gate({
                store: true,
                data:  $('#xReturningUserEmail')
                  .eq(0)
                  .val(),
                type: 'Age',
              });
            } else {
              // Otherwise, use the campaign id as the unique value.
              NGX.App.api.gate({ store: true, data: NGX.App.config.id, type: 'Age' });
            }
          } else {
            // If a minimum age is set AND < current age
            if (this.attr('data-ngx-minage')) {
              const minAge = getAge(this.attr('data-ngx-minage'));
              return Object.assign(errorTypes, { valid: yearsDiff <= minAge, msg: NGX.lang.form.dateofbirth.invalidAge.replace('{age}', Math.abs(minAge)) });
            }

            return Object.assign(errorTypes, { valid: true });
          }
        }
        return Object.assign(errorTypes, { valid: false });
      } else {
        return errorTypes;
      }
    },
  },
};
